function toggle(isEnabled) {
  document.documentElement.classList.toggle('qh-banner-enabled', isEnabled)
  if (!isEnabled) {
    localStorage.setItem('qh-banner-viewed', 'yes')
  }
}

function initQuarterHorizonsBanner() {
  const closeBtn = document.querySelector('.qh-banner__close')
  const overlay = document.querySelector('.qh-overlay')

  closeBtn.addEventListener('click', () => {
    toggle(false)
  })

  overlay.addEventListener('click', () => {
    toggle(false)
  })

  if (localStorage.getItem('qh-banner-viewed') !== 'yes') {
    toggle(true)
  }
}

export default initQuarterHorizonsBanner
